import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=33c73fdd&scoped=true"
import script from "./Wait.vue?vue&type=script&lang=js"
export * from "./Wait.vue?vue&type=script&lang=js"
import style0 from "./Wait.vue?vue&type=style&index=0&id=33c73fdd&prod&lang=scss&scoped=true"
import style1 from "./Wait.vue?vue&type=style&index=1&id=33c73fdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c73fdd",
  null
  
)

export default component.exports